import { TABLE_CARD_BODY_CELL, TableCardRow } from "@/components/Table";

type DashboardEmptyRowProps = {
  columnCount: number;
  message: string;
  rowTestId: string;
};

export default function DashboardEmptyRow({ columnCount, message, rowTestId }: DashboardEmptyRowProps) {
  const content = <span className="text-body-medium text-sys-brand-on-surface-variant">{message}</span>;

  return (
    <TableCardRow columnCount={columnCount} rowTestId={rowTestId} mobile={content}>
      <td colSpan={columnCount} className={TABLE_CARD_BODY_CELL}>
        {content}
      </td>
    </TableCardRow>
  );
}
